<template>
	<section>
		<!--工具条-->
		<el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
			<el-form :inline="true" :model="confs.filters">
				<el-form-item v-for="item in confs.query">
					<el-input v-if="item.elType=='el-input'" v-model="confs.filters[item.key]" :placeholder="item.title"></el-input>
					<el-select v-else-if="item.elType=='el-select'" 
						v-model="confs.filters[item.key]" :placeholder="item.title" class="h-m-select">
						<el-option v-for="selectItem in confs.selectList[item.listkey].data" 
							:key="selectItem[item.opkey]" :label="selectItem[item.opval]" 
							:value="selectItem[item.opkey]">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" icon="el-icon-search" @click="getLists">搜索</el-button>
				</el-form-item>
				<el-form-item>
					<el-button type="info" plain @click="cleanQuery">清空条件</el-button>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" icon="el-icon-document-add" @click="handleAdd">新增</el-button>
				</el-form-item>
			</el-form>
		</el-col>
		<!--列表-->
		<el-table :data="datalist" border stripe highlight-current-row v-loading="listLoading" style="width:90%;" height="500"
			cell-class-name="cell-content-top" @row-click="rowClick">
			<el-table-column label="操作" width="100">
				<template slot-scope="scope">
					<div style="margin-bottom: 8px;">
						<el-button v-if="scope.row.status<=2" type="primary" plain size="mini" @click="addNums(scope.$index, scope.row)">添加线索</el-button>
					</div>
					<div v-if="scope.row.status==2||scope.row.status==4" style="margin-bottom: 8px;">
						<el-button type="success" icon="el-icon-video-play" plain size="mini" @click="uptStat(scope.row,'3')">开始</el-button>
					</div>
					<div v-if="scope.row.status==3" style="margin-bottom: 8px;">
						<el-button type="warning" icon="el-icon-video-pause" plain size="mini" @click="uptStat(scope.row,'4')">暂停</el-button>
					</div>
					<div style="margin-bottom: 8px;">
						<el-button v-if="scope.row.called_counts<=0" type="danger" icon="el-icon-delete" plain size="mini" @click="handleDel(scope.$index, scope.row)">删除</el-button>
					</div>
				</template>
			</el-table-column>
			<el-table-column prop="" label="任务信息">
				<template slot-scope="scope">
					<div>
						<font style="font-size:12px;">{{scope.row.entime}}</font><br/>
						<font style="font-size:13px;color:green">{{scope.row.name}}</font><br/>
						<font style="font-size:12px;">{{showLabs(scope.row.company_code,'company','code','name')}}</font><br/>
						<font v-if="scope.row.status==1" style="font-size:13px;color:#2b85e3;">{{showLabs(scope.row.status,'status','keystr','val')}}</font>
						<font v-else-if="scope.row.status==2" style="font-size:13px;color:#ea8d00;">{{showLabs(scope.row.status,'status','keystr','val')}}</font>
						<font v-else-if="scope.row.status==3" style="font-size:13px;color:#15dcb3;">{{showLabs(scope.row.status,'status','keystr','val')}}</font>
						<font v-else-if="scope.row.status==4" style="font-size:13px;color:#f80909;">{{showLabs(scope.row.status,'status','keystr','val')}}</font>
						<font v-else-if="scope.row.status==5" style="font-size:13px;color:green;">{{showLabs(scope.row.status,'status','keystr','val')}}</font>
					</div>
				</template>
			</el-table-column>
			<el-table-column prop="status" label="基本配置">
				<template slot-scope="scope">
					<div>
						<font style="font-size:12px;">{{scope.row.start_time}}--{{scope.row.end_time}}</font><br/>
						<div v-for="(ins,index) in scope.row.call_nums" class="var-text"> 
							主叫{{index+1}}:<font style="font-weight: bold;color:#a16408;text-decoration: underline;">{{ins.nm}}</font>
						</div>
						<hr size="1">
						<div v-for="(ins,index) in scope.row.variables" class="var-text"> 
							设置:{{ins.kn}} = <font style="font-weight: bold;color:#1b79dc;text-decoration: underline;">{{ins.val}}</font>
						</div>
					</div>
				</template>
			</el-table-column>
			<el-table-column prop="status" label="线索数据">
				<template slot-scope="scope">
					线索:{{scope.row.num_counts}}&nbsp;&nbsp;
					<div style="margin-bottom: 8px;">
						<el-button v-if="scope.row.status<=2" type="primary" plain size="mini" @click="loadFileNums(scope.$index, scope.row)">导入线索</el-button>
					</div>
					<br/>
					完成:{{scope.row.called_counts}}&nbsp;&nbsp;时长:{{scope.row.call_mins}}<br/>
					成功:{{scope.row.called_ok}}&nbsp;&nbsp;失败:{{scope.row.called_err}}
				</template>
			</el-table-column>
		</el-table>
		<!--工具条翻页-->
		<el-col :span="21" class="toolbar">
		<el-pagination layout="total,prev, pager, next" @current-change="handleCurrentChange" :page-size="pagesize" :total="total" style="float:right;"></el-pagination>
		</el-col>

		<!--编辑界面-->
		<el-drawer
		  :title="editformtitle"
		  :visible.sync="editFormVisible" :before-close="clickClose"
		  size="50%" :with-header="false"
		  direction="rtl">
			<el-form :model="editForm" label-width="100px" :rules="formRules" ref="editForm" label-width="180px">
				<el-container style="min-height: 100vh;">
					<!-- <el-header style="position: fixed; top: 0; width: 100%; z-index: 1024;height:150px;padding-top:15px;">
					-->
					<!-- 头部内容 -->			  
					<!--
					</el-header> -->
					<el-main style="padding: 10px;">
						<div style="display: flex;justify-content: center;">
							<div style="width:50%;display: inline-block;margin: 0 auto;margin-bottom:25px;">
								<el-steps :active="taskActive" finish-status="success">
								  <el-step title="选择任务"></el-step>
								  <el-step title="选择号码"></el-step>
								</el-steps>
							</div>
						</div>
						<el-form-item label="选择话术" prop="call_script_id" class="is-required">
							<el-select 
								@change="selectScript"
								v-model="editForm.call_script_id" filterable placeholder="请输入/请选择" class="h-m-select">
							  <el-option v-for="item in strpitList"
								:key="item.id" :label="item.name" v-model="item.id">
							  </el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="任务名称" prop="name" class="is-required">
							<el-input v-model="editForm.name" placeholder="请输入名称"></el-input>
						</el-form-item>
						<el-form-item label="开始时间" prop="start_time" class="is-required">
							<el-date-picker
							  v-model="editForm.start_time" type="datetime"
							  placeholder="选择开始日期时间">
							</el-date-picker>
						</el-form-item>
						<el-form-item label="结束时间" prop="start_time" class="is-required">
							<el-date-picker
							  v-model="editForm.end_time" type="datetime"
							  placeholder="选择开始日期时间">
							</el-date-picker>
						</el-form-item>
						<el-form-item label="主叫">
							<div v-for="(ins,index) in editForm.call_nums" class="var-text"> 
								主叫{{index+1}}:<font style="font-weight: bold;color:#a16408;text-decoration: underline;">{{ins.nm}}</font>
							</div>
						</el-form-item>
						<el-form-item label="信息">
							<div v-for="(ins,index) in editForm.variables" class="var-text"> 
								设置:{{ins.kn}} = <font style="font-weight: bold;color:#1b79dc;text-decoration: underline;">{{ins.val}}</font>
							</div>
						</el-form-item>
					</el-main>
					<el-footer>
						<div class="to-right">
							<el-button @click.native="editFormVisible = false">取消</el-button>
							<el-button type="primary" @click.native="editSubmit" :loading="editLoading">保存</el-button>
						  </div>
					</el-footer>
				</el-container>
			</el-form>
		</el-drawer>
		
		<el-drawer
		  :title="editformtitle"
		  :visible.sync="addFormVisible" :before-close="clickCloseQueryPhones"
		  size="50%"
		  direction="rtl">
			<el-container style="min-height: 100vh;">
				<!-- <el-header style="position: fixed; top: 0; width: 100%; z-index: 1024;padding-top:15px;">
					{{addNumsForm.name}} 添加线索
				头部内容 		  
				</el-header>-->	
				<el-main style="padding: 10px;margin-top:10px;">
					<el-form :inline="true" :model="queryPhones" ref="queryPhones">	
						<el-form-item>
							<el-date-picker v-model="queryPhones.entimes" style="width:150px"
							  type="date" placeholder="选择开始日期" value-format="yyyy-MM-dd">
							</el-date-picker>
						</el-form-item>
						<el-form-item>
							<el-date-picker v-model="queryPhones.entimee" style="width:150px"
							  type="date" placeholder="选择结束日期" value-format="yyyy-MM-dd">
							</el-date-picker>
						</el-form-item>
						<el-form-item>
							<el-input style="width:150px" v-model="queryPhones.groups" placeholder="请输入导入批次"></el-input>
						</el-form-item>
						<el-form-item>
							<el-button type="primary" icon="el-icon-search" @click="getPhonesLists">搜索</el-button>
						</el-form-item>
						<el-form-item>
							<el-button icon="el-icon-search" @click="cleanQueryPhone">清空</el-button>
						</el-form-item>
						<el-form-item>
							<el-button type="primary" @click.native="editAddSubmit" :loading="editLoading">添加选中的线索</el-button>
						</el-form-item>
						<el-form-item>
							<el-button type="primary" @click.native="editAddQuerySubmit" :loading="editLoading">添加条件的线索</el-button>
						</el-form-item>
					</el-form>
					<el-table :data="phonesDatalist" border stripe highlight-current-row v-loading="listLoading" style="width:90%;" height="450"
						cell-class-name="cell-content-top" @selection-change="handleSelectionChange">
						<el-table-column type="selection" width="55"></el-table-column>
						<el-table-column prop="entime" label="时间" width="180"></el-table-column>
						<el-table-column prop="phone" label="线索" width="120"></el-table-column>
						<el-table-column prop="groups" label="批次" width="150"></el-table-column>
						<el-table-column prop="name" label="姓名" width="150"></el-table-column>
						<el-table-column prop="sextype" label="性别" width="140">
							<template slot-scope="scope">
								{{showLabs(scope.row.sextype,'sextype','keystr','val')}}
							</template>
						</el-table-column>
						<el-table-column prop="age" label="年龄" width="110"></el-table-column>
					</el-table>
					<el-col :span="21" class="toolbar">
						<el-pagination layout="total,prev, pager, next" @current-change="handleQueryCurrent" :page-size="pagesize" :total="phonetotal" style="float:right;"></el-pagination>
					</el-col>
				</el-main>
				<!--
				<el-footer>
					<div class="to-right">
						<el-button @click.native="addFormVisible = false">取消</el-button>
						
					  </div>
				</el-footer>
				-->
			</el-container>
		</el-drawer>
		
		<el-drawer
		  :visible.sync="showCallListVisble" :before-close="clickCloseCall"
		  size="55%"
		  direction="rtl">
			<el-form :model="addNumsForm" label-width="150px" :rules="formAddRules" ref="addNumsForm" label-width="180px">
				<el-container style="min-height: 100vh;">
					<el-main style="padding: 10px;">
						<el-table :data="callDetailList" border stripe highlight-current-row v-loading="callDetailLoading" style="width:90%;" 
							height="500" cell-class-name="cell-content-top" @row-click="rowDetailClick">
							<el-table-column prop="phone" label="线索"></el-table-column>
							<el-table-column prop="status" label="状态">
								<template slot-scope="scope">
									{{showLabs(scope.row.status,'callStatus','keystr','val')}}
								</template>
							</el-table-column>
							<el-table-column prop="status" label="线索状态">
								<template slot-scope="scope">
									<div style="font-size:11px;">{{showLabs(scope.row.job_status,'calledStatus','keystr','val')}}</div>
								</template>
							</el-table-column>
							<el-table-column prop="use_time" label="时长秒"></el-table-column>
							<el-table-column prop="status" label="其他">
								<template slot-scope="scope">
									<div v-for="ins in scope.row.summary" class="var-text"> 
										{{ins.key}}=<font style="font-weight: bold;color:#a16408;text-decoration: underline;">{{ins.val}}</font>
									</div>
								</template>
							</el-table-column>
						</el-table>
					</el-main>
				</el-container>
			</el-form>
		</el-drawer>
		<el-drawer
		  :visible.sync="showCallDetailVisble" :before-close="closeShowCall"
		  size="40%" direction="rtl">
			<el-container style="min-height: 100vh;">
				<el-main style="padding: 20px;">
					<el-card class="box-card">
					  
					  <div v-for="o in talk_json" :key="o" class="text item">
						{{o.speaker}}:{{o.script}}
					  </div>
					</el-card>
				</el-main>
			</el-container>
		</el-drawer>
		<el-drawer
		  :visible.sync="addLoadFileVisble" :before-close="closeAddFile"
		  size="40%" direction="rtl">
			<el-container style="min-height: 100vh;">
				<el-main style="padding: 20px;">
					<el-upload
					  class="upload-demo"
					  drag
					  :action="fileServerPath"
					  multiple>
					  <i class="el-icon-upload"></i>
					  <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
					  <div class="el-upload__tip" slot="tip">只能上传cvs且不超过500kb</div>
					</el-upload>
				</el-main>
			</el-container>
		</el-drawer>
	</section>
</template>
<script>
	import util from '../../common/js/util'
	import { getListPage, delData, saveData } from '../../api/api';
	export default {
		data() {
			return {
				testStr:'',
				cfids:'',
				confs:{},
				datalist: [],
				total: 0,
				pagesize:20,
				page: 1,
				listLoading: false,
				/////////////Form 表单
				editformtitle:'',//form编辑名称
				editFormVisible: false,//编辑界面是否显示
				editLoading: false,
				strpitList:[],
				taskActive:0,
				editForm:{
					call_script_id:'',
					name:'',company_code:'',provider_code:'',
					start_time:'',//启动时间
					end_time:'',//结束时间
					status:'1',
					script_id:'',instance_id:'',
					call_nums:'',variables:'',
					runexec:'getUUidKey',
					uuidkeyname:'call_task_id' //脚本ID，需要自动生成...
				},
				addFormVisible:false,
				phonespage:1,
				phonetotal:0,
				queryPhones:{
					entimes:'',
					entimee:'',
					groups:'',
					company_code:'',
					call_task_id:''
				},
				phonesDatalist:[],
				addNumsForm:{
					groups:'',
					name:'',
					call_task_id:''
				},
				formRules: {
					call_script_id: [
						{ required: true, message: '请选择任务', trigger: 'blur' }
					],
					name: [
						{ required: true, message: '任务名称不能为空', trigger: 'blur' }
					]
				},
				formAddRules:{
					groups: [
						{ required: true, message: '请输入线索批次', trigger: 'blur' }
					]
				},
				showCallListVisble:false,
				callDetailLoading:false,
				callDetailList:[],
				showCallDetailVisble:false,
				talk_json:[],
				checkPhoneDatas:[],
				addLoadFileVisble:false,
				fileServerPath:''
			}
		},
		methods: {
			closeAddFile:function(){
				this.addLoadFileVisble = false;
			},
			clickCloseQueryPhones:function(){
				this.addFormVisible = false ;
			},
			handleSelectionChange(val) {
				this.checkPhoneDatas = val;
				//console.log(val); // 打印选中的行数据
			},
			clickCloseCall:function(){
				this.showCallListVisble = false;
			},
			closeShowCall:function(){
				this.showCallDetailVisble = false ;
			},
			rowDetailClick:function(row,column,e){
				this.showCallDetailVisble = true ;
				this.talk_json = row.talk_json;
			},
			rowClick:function(row,column, e){
				if(row.status=='1' || row.status=='2') return ;
				let tlbTime = row.entime.substring(0,4)+row.entime.substring(5,7);
				//console.log(">>>"+row.id+">>"+tlbTime);
				this.showCallListVisble = true ;
				this.callDetailList=[];
				this.callDetailLoading = true ;
				let para = {
					page:1,pagesize:20,
					actionurl:'default/getList',
					sqlid:'6HIwMnQt.callHis.query',
					tblMonth:tlbTime
				};
				para.call_task_id = row.call_task_id ;
				getListPage(para).then((res) => {
					this.callDetailLoading = false ;
					if(res.data.status==-200){
						this.$message({
							message: res.data.message,
							type: res.data.type
						});
					}else{
						this.callDetailList = res.data.datas;
					}
				});
				
			},
			uptStat:function(row,statusStr){
				let para = {
					actionurl:'calls/uptSt',
					id:row.id,
					status:statusStr
				};
				delData(para).then((res) => {
					this.listLoading = false;
					this.$message({message: res.data.message,type: res.data.type});
					this.getLists();
				});
			},
			cleanQueryPhone:function(){
				this.queryPhones.entimes='';
				this.queryPhones.entimee='';
				this.queryPhones.groups='';
			},
			addNums:function(index, row){
				this.addFormVisible = true ;
				this.cleanQueryPhone();
				//this.addNumsForm.name = row.name;
				this.queryPhones.call_task_id = row.call_task_id;
				//this.addNumsForm.groups = '';
				this.queryPhones.company_code = row.company_code;
				this.getPhonesLists();
			},
			loadFileNums:function(index, row){
				this.addLoadFileVisble = true ;
				this.fileServerPath = "/api/calls/addFile?cid="+row.company_code+"&call_task_id="+row.call_task_id;
			},
			editAddQuerySubmit:function(){
				//看条件数据
				//保存
				if(this.queryPhones.entimes==''&&this.queryPhones.entimee==''&&this.queryPhones.groups=='') {
					this.$message({message:'需要选择至少一个条件添加线索!',type:'error'});
					return ;
				}
				let para = {actionurl:'calls/addNums',call_task_id:this.queryPhones.call_task_id};
				para.entimes = this.queryPhones.entimes;
				para.entimee = this.queryPhones.entimee;
				para.groups = this.queryPhones.groups;
				para.company_code = this.queryPhones.company_code;
				this.$refs.queryPhones.validate((valid) => {
					if (valid) {
						this.$confirm('确认提交吗？', '提示', {}).then(() => {
							getListPage(para).then((res) => {
								this.$message({
									message: res.data.message,
									type: res.data.type
								});
								this.addFormVisible = false ;
								//准备获取list
								this.getLists();
							});
						});
					}
				});
			},
			editAddSubmit:function(){
				//保存
				if(this.checkPhoneDatas.length<=0) {
					this.$message({message:'请选选择需要的线索!',type:'error'});
					return ;
				}
				let para = {actionurl:'calls/addSelectNums',call_task_id:this.queryPhones.call_task_id};
				para.addPhones = JSON.stringify(this.checkPhoneDatas);
				this.$refs.queryPhones.validate((valid) => {
					if (valid) {
						this.$confirm('确认提交吗？', '提示', {}).then(() => {
							getListPage(para).then((res) => {
								this.$message({
									message: res.data.message,
									type: res.data.type
								});
								this.addFormVisible = false ;
								//准备获取list
								this.getLists();
							});
						});
					}
				});
			},
			selectScript:function(){
				this.editForm.start_time = util.formatDate.getNow();
				this.editForm.end_time = util.formatDate.getdatestr(1,"yyyy-MM-dd hh:mm");
				for(let json of this.strpitList){
					if(this.editForm.call_script_id==json.id){
						this.editForm.name = json.name + util.formatDate.getPatternNow('yyyyMMddHHmmss');
						this.editForm.script_id = json.script_id;
						this.editForm.instance_id = json.instance_id;
						this.editForm.call_nums = json.call_nums;
						this.editForm.variables = json.variables;
						this.editForm.provider_code = json.provider_code;
						break;
					}
				}
			},
			getStrpitList:function(){
				let para = {
					actionurl:'default/getListAll',
					sqlid:'Uc9qKfB8.callScriptUse.query',
					company_code:this.confs.filters['company_code']
				};
				getListPage(para).then((res) => {
					if(res.data.status==-200){
						this.$message({
							message: res.data.message,
							type: res.data.type
						});
					}else{
						this.strpitList = res.data.datas;
					}
				});
			},
			cleanQuery:function(){
				for(let item of this.confs.query){
					this.confs.filters[item.key] = '';
				}
			},
			isObject:function(value) {
			  return typeof value === 'object' && value !== null;
			},
			clickClose:function(){},
			showLabs:function(keystr,listkey,opkey,opval){
				let reStr = '';
				if(!this.isObject(this.confs.selectList[listkey])) return keystr;
				if(!this.isObject(this.confs.selectList[listkey].data)) return keystr;
				for (var item of this.confs.selectList[listkey].data) {
					//console.log(item[opkey]+'='+item[opval]+','+keystr);
					if(item[opkey]==keystr) {
						reStr = item[opval];
						break ;
					}
				}
				return reStr ;
			},
			getConf:function(){
				let para = {actionurl:'default/getCfs','sqlid':'getcf',id:this.cfids};
				this.listLoading = true;
				getListPage(para).then((res) => {
					if(!util.checkLogOut(this,res.data)){
						this.confs = res.data.confs;
						/////////////
						if(this.isObject(this.confs.selectList)){
							for (let [key, value] of Object.entries(this.confs.selectList)) {
								//console.log("key="+key+",,,"+value);
								this.getLabList(key,value);
							}
						}
						//准备获取list
						this.getLists();
					}
					this.listLoading = false;
				});
			},
			getLabList:function(keyName,objJson){
				let para = {actionurl:objJson.acturl,sqlid:objJson.sqlid,code:objJson.code};
				getListPage(para).then((res) => {
					if(!util.checkLogOut(this,res.data)){
						this.confs.selectList[keyName].data = res.data.datas;
						console.log(this.confs.selectList[keyName].data);
					}
					//this.listLoading = false;
				});
			},
			handleQueryCurrent:function(val){
				this.phonespage = val;
				this.getPhonesLists();
			},
			getPhonesLists:function(){
				console.log("<<<"+this.queryPhones.entimes);
				let para = Object.assign({}, this.queryPhones);
				para.page = this.phonespage;
				para.pagesize = this.pagesize;
				para.actionurl='default/getList';
				para.sqlid = 'SekVHmq8.numbers.query';
				this.listLoading = true;
				getListPage(para).then((res) => {
					if(!util.checkLogOut(this,res.data)){
						this.phonetotal = res.data.total;
						this.phonesDatalist = res.data.datas;
					}
					this.listLoading = false;
				});
			},
			getLists:function(){
				let para = Object.assign({}, this.confs.filters);
				para.page = this.page;
				para.pagesiz = this.pagesize;
				para.actionurl='default/getList';
				para.sqlid=this.confs.sqls.query;
				
				this.listLoading = true;
				getListPage(para).then((res) => {
					if(!util.checkLogOut(this,res.data)){
						this.total = res.data.total;
						this.datalist = res.data.datas;
					}
					this.listLoading = false;
				});
			},
			handleAdd:function(){
				if(this.confs.filters['company_code']=='') {
					this.$message({message: '请选择公司!',type: 'error'});
					return ;
				}
				this.getStrpitList();//获取脚本
				this.editFormVisible = true;
				this.editForm.actionurl = 'default/save';
				this.editForm.sqlid = this.confs.sqls.add ;
				this.editForm.company_code = this.confs.filters['company_code'] ;
			},
			handleEdit: function (index, row) {
				this.editFormVisible = true;
				this.editformtitle = '编辑';
				for (let [key, value] of Object.entries(row)) {
					if(this.isObject(value)) {
						this.confs.editForm[key] = JSON.stringify(value);
					}else {
						this.confs.editForm[key] = value;
					}
				}
				//console.log('handleEdit>>'+this.editForm.shop_code);
				this.confs.editForm.actionurl = 'default/save';//设置Sqlid
				this.confs.editForm.sqlid = this.confs.sqls.upt;
			},
			editSubmit:function(){
				this.taskActive ++ ;
				let para = Object.assign({}, this.editForm);
				para.call_nums = JSON.stringify(this.editForm.call_nums);
				para.variables = JSON.stringify(this.editForm.variables);
				//console.log('handleEdit>>'+para.actionurl+'><'+para.shop_code);
				//util.saveByFormFunction(this,'editForm',para);
				util.saveFunction(this,para);
			},
			isObjectExists:function(obj) {
			  return typeof obj !== 'undefined' && obj !== null;
			},
			handleDel: function (index, row) {
				this.$confirm('确认删除该记录吗?', '提示', {type: 'warning'}).then(() => {
					this.listLoading = true;
					if(this.isObjectExists(this.confs.delcheck)){
						//let para = {
						//	actionurl:'default/getListAll',
						//	spcode:row.spcode,
						//	sqlid:this.confs.delcheck.checkSql
						//};
						this.confs.delcheck.code = row.code;
						//this.confs.delcheck.checkNoid = row.id;
						getListPage(this.confs.delcheck).then((res) => {
							if(!util.checkLogOut(this,res.data)){
								if(res.data.total>0) {
									this.$message({message: "此记录被使用，暂不可删除!",type: "error"});
								}
								else {
									this.$message({message: "此记录未被使用，正在删除中!",type: "success"});
									let para = {
										actionurl:'default/del',
										sqlid:this.confs.sqls.del,
										id:row.id
									};
									delData(para).then((res) => {
										this.listLoading = false;
										this.$message({message: res.data.message,type: res.data.type});
										this.getLists();
									});
								}
							}
							this.listLoading = false;
						});
					}else{
						let para = {
							actionurl:'default/del',
							sqlid:this.confs.sqls.del,
							id:row.id
						};
						delData(para).then((res) => {
							this.listLoading = false;
							this.$message({message: res.data.message,type: res.data.type});
							this.getLists();
						});
					}
				}).catch(() => {});
			}
		},
		mounted() {
			this.cfids = "rrhGaALD";//this.$route.query.cfids;
			this.getConf();
		}
	}	
</script>
<style scoped>
	.el-header {
	  background-color:#eceef3;
	  color: #409eff;
	  padding-left:50px;
	  text-align: left;
	  line-height: 60px;
	}
	.el-footer{
		padding-top:10px;
		position:absolute;
		bottom:0;
		width:100%;
		background:#f7f9fd;
		color:white;
	}
	.to-right{
		position: fixed;
		right: 20px;
	}
	.el-main {
	  margin-top: 60px; /* 头部高度 */
	  padding: 0px;
	  margin-right:20px;
	  margin-bottom:40px;
	}
	.box-card-edit{
		height:500px;
	}
	.form-item-content{
		line-height:30px;
		position:relative;
		font-size:14px;
	}
	.cell-content-top {
	  display: inline-block; /* 或者其他方式，确保内容不是块级元素 */
	  vertical-align: top;
	}
</style>


// WEBPACK FOOTER //
// taskList.vue?723631e6